import { Modal } from 'antd';
import HTTPStatus from 'http-status';

import { loginEsborrarDadesUsuariRegistrat } from '../actions/login';
import { ERROR_CONSULTA_SERVIDOR } from '../actions/actionTypes';
import { eliminarToken } from '../commons/gestioWebToken';
import { crearMissatgeError } from '../commons/missatgeServidor';

let modalErrorActiu;

const obrirModal = (onOk) => {
    if (modalErrorActiu) {
        modalErrorActiu.destroy();
    }

    modalErrorActiu = Modal.error({
        title: 'Sessió caducada',
        content: 'Les accions en curs s\'han cancel·lat',
        okText: 'Tornar a l\'inici',
        onOk
    });
};

const errorsConsultaServidor = () => next => action => {

    if (action.type === ERROR_CONSULTA_SERVIDOR) {
        const { error, missatgePerUsuari } = action;

        if (error.status === HTTPStatus.UNAUTHORIZED) {
            const onOkModal = () => {
                eliminarToken();
                next(loginEsborrarDadesUsuariRegistrat());
            };

            obrirModal(onOkModal);
            return;
        } else {
            crearMissatgeError(missatgePerUsuari);
            return;
        }
    }

    return next(action);
};

export default errorsConsultaServidor;


// WEBPACK FOOTER //
// ./src/middlewares/errorsConsultaServidor.js